import { CSSProperties, SVGProps, useState } from "react";
import "./accordion.css";
import { LuMinus } from "react-icons/lu";
import { GoPlus } from "react-icons/go";

export type BaseAccordionProps = {
  expandMultiple?: boolean;
  accordionItems: {
    title: string;
    message?: string;
    customItemComponent?: React.ReactNode;
    accordionStyle?: CSSProperties;
    headerStyle?: CSSProperties;
    expandIcon?: React.FC<SVGProps<SVGSVGElement>>;
    collapseIcon?: React.FC<SVGProps<SVGSVGElement>>;
    iconPosition?: "start" | "end";
  }[];
  defaultExpandedIndex?: number;
  expandByDefault?: boolean;
  customHeader?: React.ReactElement;
};

export const BaseAccordion = ({
  expandMultiple = false, // Default to single expansion
  accordionItems,
  // customHeader: CustomHeader,
  // customItemComponent: CustomItemComponent,
  defaultExpandedIndex = 0,
  expandByDefault = true,
}: BaseAccordionProps) => {
  const [activeExpandedAccordionIndex, setActiveExpandedAccordionIndex] =
    useState<number[]>(
      expandByDefault
        ? [defaultExpandedIndex >= 0 ? defaultExpandedIndex : 0]
        : [-1]
    );

  const handleToggleAccordionOpen = (index: number) => {
    setActiveExpandedAccordionIndex((prevActiveIndex) => {
      if (prevActiveIndex.includes(index)) {
        // If the index is already active, remove it from the active list
        return prevActiveIndex.filter((i) => i !== index);
      } else {
        // Add the index to the active list
        if (expandMultiple) {
          return [...prevActiveIndex, index];
        } else {
          // Only one index can be active at a time
          return [index];
        }
      }
    });
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
      {accordionItems?.map((accordionItem, index) => {
        return (
          <div
            className={"accordion"}
            key={index}
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "1rem",

              // padding: ".625rem 1rem .625rem 1.25rem",
              // border: "1px solid #0a0f2914",
              // backgroundColor: "white",
              ...accordionItem?.accordionStyle,
            }}
          >
            <div
              className={`subtitle border border-[#FFFFFF24] w-full flex-col ${
                activeExpandedAccordionIndex.includes(index)
                  ? "bg-[#14151A]"
                  : "bg-[#0B0C0E]"
              } bg-[#0B0C0E] justify-center flex rounded-lg`}
              onClick={() => handleToggleAccordionOpen(index)}
              style={{
                display: "flex",
                width: "100%",
                // gap: "1rem",
                // justifyContent: "between",
                padding: "20px 16px 20px 16px",
                // justifyContent: "space-between",
                // flexDirection: accordionItem?.iconPosition == "start" ? "row" : "row-reverse",
                ...accordionItem?.headerStyle,
              }}
            >
              <div className="flex-row flex justify-between items-center">
                <p
                  style={{
                    color: "var(--gray--5)",
                    fontWeight: 600,
                  }}
                >
                  {accordionItem.title}
                </p>
                <div>
                  {activeExpandedAccordionIndex.includes(index) ? (
                    <LuMinus className={"icon"} color="white" />
                  ) : (
                    <GoPlus className={"icon"} color="white" />
                  )}
                </div>
              </div>
              <div>
                {!accordionItem?.customItemComponent &&
                  activeExpandedAccordionIndex.includes(index) &&
                  accordionItem.message && (
                    <p
                      style={{
                        whiteSpace: "pre",
                        textWrap: "wrap",
                        overflowWrap: "break-word",
                      }}
                      className={`accordion-content text-tertiary subtitle label ${
                        activeExpandedAccordionIndex.includes(index)
                          ? "expanded"
                          : ""
                      }`}
                    >
                      {accordionItem.message}
                    </p>
                  )}
              </div>
            </div>
            {accordionItem?.customItemComponent &&
              activeExpandedAccordionIndex.includes(index) &&
              accordionItem?.customItemComponent}
          </div>
        );
      })}
    </div>
  );
};
